import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement } from "react";

export const Fieldset = ({
  className,
  ...props
}: { className?: string } & Omit<
  Headless.FieldsetProps,
  "as" | "className"
>): ReactElement => (
  <Headless.Fieldset
    {...props}
    className={clsx(
      className,
      "[&>*+[data-slot=control]]:mt-6 [&>[data-slot=text]]:mt-1",
    )}
  />
);
